import React, { useEffect, useState } from "react";

// STYLES
import * as Style from "./EditLockerStyle";

// LIBRARIES
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

// MISC
import { ButtonTypes, InputTypes, lockerCurencies } from "models/GeneralTypes/generalTypes";
import { ILocker } from "models/interfaces";

// ASSETS

// REDUX
import { deleteLocker, editLocker, getLocker } from "api/lockerApi";
import { useAppDispatch } from "hooks/reduxHooks";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import SelectAtom from "components/Atoms/SelectAtom/SelectAtom";
import TimePickerAtom from "components/Atoms/TimePickerAtom/TimePickerAtom";

const EditLocker = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS
  const [lockerDetailsValues, setLockerDetailsValues] = useState<ILocker>({
    longitude: "",
    latitude: "",
    name: "",
    address: "",
    price: "",
    noOfAvailableSlots: "",
    noOfAvailableSupBoards: "",
    noOfSlots: "",
    noOfSupBoards: "",
    startHour: dayjs("HH:mm:ss", "21:11:22"),
    endHour: dayjs("HH:mm:ss", "21:22:11"),
  });
  const [selectedCurrency, setSelectedCurrency] = useState<string>();

  // GENERAL CONSTANTS
  const { lockerId } = location.state as Props;

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(getLocker(lockerId))
      .unwrap()
      .then((response) => {
        let lockerDetails = {
          ...response,
          startHour: dayjs(response.startHour, "HH:mm:ss"),
          endHour: dayjs(response.endHour, "HH:mm:ss"),
        };
        setLockerDetailsValues(lockerDetails);
      });
    // eslint-disable-next-line
  }, []);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleChangeLockerDetailsData = (
    name: string,
    value: React.SetStateAction<any>
  ) => {
    setLockerDetailsValues({
      ...lockerDetailsValues,
      [name]: value,
    });
  };

  const handleEditLocker = () => {
    let lockerDetails: any = {
      ...lockerDetailsValues,
      startHour: lockerDetailsValues.startHour,
      endHour: lockerDetailsValues.endHour,
    };
    console.log("payload", lockerDetails)
    dispatch(editLocker(lockerDetails));
    navigate("/lockerList");
  };

  const handleDeleteLocker = () => {
    dispatch(deleteLocker(lockerId))
      .unwrap()
      .then(() => navigate("/lockerList"));
  };

  return (
    <Style.Container>
      <Style.ContainerDetails>
        <Style.RowWrapper>
          <Style.BigElementContainer>
            <Style.InputContainer>
              <InputAtom
                inputValue={lockerDetailsValues.name}
                setInputValue={(value) =>
                  handleChangeLockerDetailsData("name", value)
                }
                placeholder={t(
                  "component.lockerFunctionality.placeholder.lockersName"
                )}
                label={t("component.lockerFunctionality.label.lockersName")}
                type={InputTypes.MODAL_INPUT}
              />
            </Style.InputContainer>
          </Style.BigElementContainer>
          <Style.BigElementContainer>
            <Style.ContainerDetailsTitle>

            </Style.ContainerDetailsTitle>
            <Style.InputContainer>
              <InputAtom
                inputValue={lockerDetailsValues.address}
                setInputValue={(value) =>
                  handleChangeLockerDetailsData("address", value)
                }
                placeholder={t(
                  "component.lockerFunctionality.placeholder.lockersAddress"
                )}
                label={t("component.lockerFunctionality.label.lockersAddress")}
                type={InputTypes.MODAL_INPUT}
              />
            </Style.InputContainer>
          </Style.BigElementContainer>
          <Style.InputContainer>
            <InputAtom
              placeholder={t(
                "component.lockerFunctionality.placeholder.latitude"
              )}
              label={t("component.lockerFunctionality.label.latitude")}
              inputValue={lockerDetailsValues.latitude}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("latitude", value)
              }
              type={InputTypes.MODAL_INPUT}
            />
          </Style.InputContainer>
          <Style.InputContainer>
            <InputAtom
              placeholder={t(
                "component.lockerFunctionality.placeholder.longitude"
              )}
              label={t("component.lockerFunctionality.label.longitude")}
              inputValue={lockerDetailsValues.longitude}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("longitude", value)
              }
              type={InputTypes.MODAL_INPUT}
            />
          </Style.InputContainer>
          <Style.InputContainer>
            <InputAtom
              label={t("component.lockerFunctionality.label.price")}
              inputValue={lockerDetailsValues.price}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("price", value)
              }
              placeholder={t("component.lockerFunctionality.placeholder.price")}
              type={InputTypes.MODAL_INPUT}
            />
          </Style.InputContainer>
          <Style.SelectInputAtomContainer>
            <SelectAtom
              options={lockerCurencies}
              selectedOptions={selectedCurrency}
              setSelectedOptions={setSelectedCurrency}
              label={t("component.lockerFunctionality.label.currency")}
            />
          </Style.SelectInputAtomContainer>
        </Style.RowWrapper>



        <Style.HoursRowWrapper>
          <Style.DateInputContainer>
            <TimePickerAtom
              label={t("component.lockerFunctionality.label.selectStartTime")}
              setValue={(value) =>
                handleChangeLockerDetailsData("startHour", value)
              }
              value={lockerDetailsValues.startHour}
            />

          </Style.DateInputContainer>
          <Style.DateInputContainer>
            <TimePickerAtom
              label={t("component.lockerFunctionality.label.selectEndTime")}
              setValue={(value) =>
                handleChangeLockerDetailsData("endHour", value)
              }
              value={lockerDetailsValues.endHour}
            />
          </Style.DateInputContainer>

        </Style.HoursRowWrapper>
        <Style.RowWrapper>

        </Style.RowWrapper>
        <Style.RowWrapper>

        </Style.RowWrapper>

        <Style.ButtonsContainer>
          <Style.ButtonContainer>
            <ButtonAtom
              text={t("component.lockerFunctionality.button.title.edit")}
              type={ButtonTypes.MAIN_BUTTON}
              onClick={handleEditLocker}
            />
          </Style.ButtonContainer>
          <Style.ButtonContainer>
            <ButtonAtom
              text={t("component.lockerFunctionality.button.title.delete")}
              type={ButtonTypes.MAIN_BUTTON}
              onClick={handleDeleteLocker}
            />
          </Style.ButtonContainer>
        </Style.ButtonsContainer>
      </Style.ContainerDetails>
    </Style.Container>
  );
};

export default EditLocker;
